import React, { useEffect, useState } from "react";
import Header from "../components/Header";
import Hero from "../components/Hero";
import About from "../components/About";
import AboutClg from "../components/AboutClg";
import Team from "../components/Team";
import Sponsors from "../components/Sponsors";
import Footer from "../components/Footer";
import Dates from "../components/Dates";
import Call from "../components/Call";
import Tracks from "../components/Tracks";
import { client } from "../config/prismic";

const Home = () => {
  const [home, setHome] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      const response = await client.getByType("home");
      setHome(response.results[0]?.data); // Accessing the first result's data directly
    };
    fetchData();
  }, []);

  if (!home) {
    return (
      <div className="loader-container">
        <div className="loader"></div>
      </div>
    );
  }
  return (
    <div>
      <Header />
      <Hero home={home} />
      <About home={home} />
      <AboutClg />
      <Dates />
      <Team />
      <Tracks />
      {/* <Sponsors /> */}
      {/* <Call /> */}
      <Footer />
    </div>
  );
};

export default Home;
